import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

// Saves a DOM element (check + voucher sheet) as a Letter-size PDF, splitting onto extra pages when taller
export const saveElementPdf = async (el, filename) => {
  const canvas = await html2canvas(el, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
  const pdf = new jsPDF({ unit: 'in', format: 'letter' });
  const w = 8.5, h = 11, margin = 0.25, iw = w - margin * 2;
  const pageHpx = Math.floor((canvas.width * (h - margin * 2)) / iw);
  for (let y = 0, i = 0; y < canvas.height; y += pageHpx, i++) {
    const slice = document.createElement('canvas');
    slice.width = canvas.width; slice.height = Math.min(pageHpx, canvas.height - y);
    slice.getContext('2d').drawImage(canvas, 0, y, canvas.width, slice.height, 0, 0, canvas.width, slice.height);
    if (i) pdf.addPage();
    pdf.addImage(slice.toDataURL('image/jpeg', 0.95), 'JPEG', margin, margin, iw, (slice.height * iw) / canvas.width);
  }
  pdf.save(filename);
};
